'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { TrackingStatus } from '@/ui/components/shared/order-details/TrackingStatus/TrackingStatus';
import DetailsTile from '@/ui/components/shared/DetailsTile';
import DetailsTileHeading from '@/ui/components/shared/DetailsTileHeading';
import { useOrderReceivedData } from '@/ui/providers/order-received-data-provider';

const ACTIVE_STEPS = new Set(['ready', 'shipped', 'delivered']);

/**
 * The delivery-tracking tile
 */
export function DeliveryTracking() {
  const data = useOrderReceivedData();
  const t = useTranslations('DeliveryTrackingTile');

  if (!data) {
    return null;
  }

  const rawStatus = data.trackingStatus ?? '';
  const status = ACTIVE_STEPS.has(rawStatus) ? rawStatus : 'ready';

  return (
    <DetailsTile>
      <DetailsTileHeading heading={t('title')} />
      <div className="mt-6">
        <TrackingStatus status={status} deliveredAsShipped={data.deliveredAsShipped} />
      </div>
    </DetailsTile>
  );
}
